import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const companyId = process.env.REACT_APP_COMPANY_ID;

export const getRoles = createAsyncThunk(
  "rolesnpermissions/getRoles",
  async (thunkAPI) => {
    try {
      const response = await axiosInstance.request({
        url: `/roles`,
        method: "get",
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los roles. Error: ",
        error
      );
    }
  }
);

export const setRole = async (data) => {
  await axiosInstance.post(`/roles`, data);
};

export const updateRole = async (id, data) => {
  await axiosInstance.put(`/roles/${id}`, data);
};

export const deleteRole = async (id, data) => {
  await axiosInstance.delete(`/roles/${id}`, "");
};

export const rolesnpermissionsSlice = createSlice({
  name: "rolesnpermissions",
  initialState: {
    permissions: [
      {
        Cupones: {
          Read: {
            name: "Permissions.Coupons.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Coupons.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Coupons.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Coupons.Export",
            isChecked: false,
          },
        },
      },
      {
        Ordenes: {
          Read: {
            name: "Permissions.Orders.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Orders.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Orders.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Orders.Export",
            isChecked: false,
          },
        },
      },
      {
        Suscripciones: {
          Read: {
            name: "Permissions.Subscriptions.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Subscriptions.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Subscriptions.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Subscriptions.Export",
            isChecked: false,
          },
        },
      },
      {
        Boletos: {
          Read: {
            name: "Permissions.Tickets.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Tickets.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Tickets.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Tickets.Export",
            isChecked: false,
          },
        },
      },
      {
        Facturación: {
          Read: {
            name: "Permissions.Invoices.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Invoices.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Invoices.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Invoices.Export",
            isChecked: false,
          },
        },
      },
      {
        Mailings: {
          Read: {
            name: "Permissions.Mailings.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Mailings.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Mailings.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Mailings.Export",
            isChecked: false,
          },
        },
      },
      {
        Asientos: {
          Read: {
            name: "Permissions.Seats.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Seats.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Seats.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Seats.Export",
            isChecked: false,
          },
        },
      },
      {
        Secciones: {
          Read: {
            name: "Permissions.Sections.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Sections.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Sections.Manage",
            isChecked: false,
          },
          Export: {
            nmae: "Permissions.Sections.Export",
            isChecked: false,
          },
        },
      },
      {
        Zonas: {
          Read: {
            name: "Permissions.Zones.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Zones.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Zones.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Zones.Export",
            isChecked: false,
          },
        },
      },
      {
        Información: {
          Read: {
            name: "Permissions.Information.Read",
            isChecked: false,
          },
          Update: {
            name: "Permissions.Information.Update",
            isChecked: false,
          },
          Manage: {
            name: "Permissions.Information.Manage",
            isChecked: false,
          },
          Export: {
            name: "Permissions.Information.Export",
            isChecked: false,
          },
        },
      },
    ],
    roles: [],
    rolesLoader: false,
  },
  reducers: {
    setSubsList: (state, action) => {
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoles.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.roles = data;
        state.rolesLoader = false;
      })
      .addCase(getRoles.pending, (state) => {
        state.rolesLoader = true;
      })
      .addCase(getRoles.rejected, (state) => {
        state.rolesLoader = false;
      });
  },
});

export default rolesnpermissionsSlice.reducer;